import HtmlParser from 'html-react-parser';
import React from 'react';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="page-integrations people-analytics" ontouchstart>
            <SEO title="People Analytics | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Everything you need to know about your team - all in one place. Drive business strategy with powerful people analytics, without the manual work."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="People Analytics | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Everything you need to know about your team - all in one place. Drive business strategy with powerful people analytics, without the manual work." />
                <meta property="og:image" content={`https://www.charthop.com/product/people-analytics/people-analytics.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="People Analytics | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Everything you need to know about your team - all in one place. Drive business strategy with powerful people analytics, without the manual work." />
                <meta name="twitter:image" content={`https://www.charthop.com/product/people-analytics/people-analytics.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="intro container">
                <div className="row pt-5 pb-5 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>People analytics that drive business strategy.</h1>
                        <p className="header-p pb-1 pt-1">Everything you need to know about your team - all in one place.</p>
                        <div className="splitText"><DemoFormShort source={"product-people-analytics-demo-header"} /></div>                        
                    </div>
                    <div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one" >
						<ReactPlayer
							url="/home/02_Reports_03_Optimized.mp4"
							playing
							loop
							muted
							playsinline
						/>
					</div>
                </div>
            </section>

            {/* customers */}
            <section className="customer testimonial-container backgroundGradientContainer pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
            </section>

            {/* HR Data */}
            <section className="sectionSpacing flex-centeredColumn">
                <h2 className="text-center mt-0 sectionSpacing-Margin">The HR Data Dashboards you've always wanted.</h2>
                <div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                        <div className="svg-info-card-3col">
							<img src={'/product/people-analytics/create.svg'} alt="Insight" />
							<h3>Easy to create</h3>
							<p>Build or edit pre-made reports to gain insights in seconds. </p>
						</div>
                         <div className="svg-info-card-3col">
							<img src={'/product/org-chart/time.svg'} alt="Update" />
							<h3>Always up to date</h3>
							<p>Integrate your existing systems for seamless, daily updates. </p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/product/people-analytics/customize.svg'} alt="Customize" />
							<h3>Highly customizable </h3>
							<p> Personalize reports with custom data, filters & complex calculations.  </p>
						</div>
					</div>
				</div>
            </section>
            
            {/* HR Data */}
            <section className="sectionSpacing backgroundGradientContainer" id="hr-data">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Centralize and collect data"
                        link="/product/people-analytics/Integration_reports-2.mp4"
                        type="video"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Report across any HR system. Integrate data from your HRIS, ATS, Equity, Performance, Identity Management tools and more.</p>
                                <p>Collect any data directly through ChartHop, without an additional survey tool.</p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            {/* Visualize */}		
			<section className="sectionSpacing" id="visualize">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Visualize your data"
                        link="/videos/visualize-dei.mp4"
                        type="video"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>Go beyond the the spreadsheets and graphs. Bring People data to life like never before.</p>
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

            {/* Analyze */}
            <section className="sectionSpacing backgroundGradientContainer" id="analyze">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Analyze your trends"
                        link="/product/performance/reports-one-on-one-ethnicity.gif"
                        type="image"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>Understand your evolution through time-tracked changes and dissect your data across any dimension. </p>
                                <p>Drill down into your data with the click of a button.</p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            <div className="sectionSpacing mx-0 mt-0">
                <div className="contentBlock">
                    <h2 className="text-center mt-0 sectionSpacing-Margin">Drive a comprehensive DE&I Strategy</h2>
                    <h4 className="text-center mt-0 sectionSpacing-Margin">Understand how key factors differ across genders, ethnicities, generations & more. </h4>
					<div className="pgc1">
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Cash Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Equity Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Total Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Levels & Titles</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Performance Reviews</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Promotions & Raises </p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Span of Control</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Engagement & Satisfaction </p>
                            </div>
                        </div>
                    </div>
					<p className="subListTitle mb-0 font-weight-bold text-center">& more</p>
				</div>
            </div>

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
            <h2 className="text-center mt-0 sectionSpacing-Margin">Built to augment your existing tools.</h2>           
               
    

                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>
                        {/* FIRST 4 */}

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* SECOND 4 */}

                        

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/gusto.png' alt="Gusto" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-rippling@2x.jpg' alt="Rippling" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div>   
                  

                        {/* <div> */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">
                        </div>
                        {/* </div> */}
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>
            

            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"product-people-analytics-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“Having an <b>accurate, single source </b> of employee data empowers better management decisions and employee transparency.</p><p class=" mb-3 contact-testimonial">It is a game changer.”</p><div class="authorTag"><img src="/supporters/jordan-wan-new.jpg" class="testimonialAuthor" alt="Shelby Wolpa" /><div><p class="contactAuthor"><strong>Jordan Wan</strong> <br>CEO, CloserIQ</p></div></div>')}/>
			</section>
        </Layout>
    );
};


export default Home;
